import { ToastrService } from 'ngx-toastr';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AssignmentForStudentDiagnostic, LessonProgressSaveGradeModel, UnassignDiagnosticLessonsVM } from 'src/app/Elearning-Models';
import { GradeDialogComponent } from 'src/app/layouts/CSA/shared/grade-dialog/grade-dialog.component';
import { IAPIService } from 'src/app/Services/API-Service/IAPIService';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ColorCodes, CSSLabel, StatusLabel } from 'src/app/ColorCodes';
import { UnassignDiaglogComponent } from 'src/app/layouts/CSA/shared/unassign-diaglog/unassign-diaglog.component';
import { ReassignDialogComponent } from 'src/app/layouts/CSA/shared/reassign-dialog/reassign-dialog.component';

@Component({
  selector: 'assignment-card-brief',
  templateUrl: './assignment-card-brief.component.html',
  styleUrls: ['./assignment-card-brief.component.scss']
})
export class AssignmentCardBriefComponent implements OnInit {
  @Input() assignment: AssignmentForStudentDiagnostic;
  @Input() classID: number;
  @Input() studentID: number;
  @Input() diagExamID: number;
  @Input() studentName: string;
  @Output() unassigned: EventEmitter<UnassignDiagnosticLessonsVM> = new EventEmitter<UnassignDiagnosticLessonsVM>();
  
  colorCode: string;
  colorIndicators = new ColorCodes().colorIndicators;

  constructor(
    private APIService: IAPIService, 
    private dialog: MatDialog,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.GetColor();
  }

  private GetColor() {
    var label: string;
    if (this.assignment.Grade && this.assignment.GradeReleased) {
      label = StatusLabel.Graded;
    }
    else if (this.assignment.Grade && !this.assignment.GradeReleased) {
      label = StatusLabel.GradeNotReleased;
    }
    else if (!this.assignment.Grade && !this.assignment.GradeReleased && this.assignment.SubmittedAsComplete) {
      label = StatusLabel.Ungraded;
    }
    else {
      // no sent back
      label = StatusLabel.Assigned;
    }

    if (this.assignment.SentBack) {
      label = StatusLabel.SentBack;
    }
    this.colorCode = this.getColorCode(label);
  }

  getColorCode(label : string){
    return this.colorIndicators.find(color => color.label == label)?.color;
  }
  onAssignmentClick = () => {
      if(this.assignment.LessonID && this.assignment.LessonID > 0){
        this.router.navigate([environment.rootPath + 'Student/' + this.studentID],
        {
          queryParams: {
            classID: this.classID,
            lessonVersionID: this.assignment.LessonID,
            studentName: this.studentName,
          },
        }
      );
      }
      
  }

  openReassignDialog(){
    const dialogRef = this.dialog.open(ReassignDialogComponent, {
      data: {
        assignment: {
          grade: this.assignment.Grade,
          gradeReleased: this.assignment.GradeReleased,
        },
        title: this.assignment.LessonName,
      },
      autoFocus: false,
    });

    const sub = dialogRef.componentInstance.reassignSelected.subscribe(
      (selectedValues) => {
        this.APIService.ReassignStudent({
          ClassID: this.classID,
          AssignmentID: this.assignment.AssignmentID,
          StudentID: this.studentID,
          ReassignShowIcon: selectedValues.selectedOption,
          ReassignShowAnswer: selectedValues.subOption,
        }).subscribe((response) => {
          if (response) {
            this.toastr.success('Student Reassigned', 'Success!');
            this.GetColor();
          } else {
            this.toastr.error('Something went wrong', 'Failure!');
          }
        });
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }

  openUnassignDialog()
  {
    const dialogRef = this.dialog.open(UnassignDiaglogComponent, {
      data: {
        lessonName: this.assignment.LessonName,
        studentName: this.studentName,
      },
      autoFocus: false,
    });


    const sub = dialogRef.componentInstance.unassignYes.subscribe(
      (result: boolean) => {
        if(result){
          this.unassignLesson();
        }
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }

  unassignLesson(){
    var model = new UnassignDiagnosticLessonsVM();
    model.AssignmentID = this.assignment.AssignmentID;
    model.DiagnosticExamID = this.diagExamID;
    model.StudentID = this.studentID;

    this.APIService.UnassignDiagnosticLessons(model).subscribe(response => {
      this.emitUnassigned(response, model);
    });
  }

  emitUnassigned(response: boolean, model: UnassignDiagnosticLessonsVM){
    if(response){
      this.unassigned.emit(model);
    }
    else{
      this.unassigned.emit(null);
    }
  }

  releaseGradeChanged =(event) => {
    this.APIService.ReleaseGradeForStudent({
      ClassID: this.classID,
      AssignmentID: this.assignment.AssignmentID,
      StudentID: this.studentID
    }).subscribe((response) => {
      if (response) {
        this.assignment.GradeReleased = event.checked;
        this.GetColor();
        if(event.checked) {
          this.toastr.success('Grade Released', 'Success!');
        } else {
          this.toastr.success('Grade Release Reversed', 'Success!');
        }
      } else {
        this.toastr.error('Something went wrong', 'Failure!');
      }
    });
  }

  onGradeClick = () => {
    this.openGradeDialog();
  }

  openGradeDialog = () => {
    const dialogRef = this.dialog.open(GradeDialogComponent, {
      data: {
        grade: this.assignment.Grade,
        title: this.assignment.LessonName,
      },
      autoFocus: false,
    });

    const sub = dialogRef.componentInstance.valueUpdated.subscribe(
      (assignment) => {
        if (assignment.grade !== null) {
          
          var model = new LessonProgressSaveGradeModel();
          model.AssignmentID = this.assignment.AssignmentID;
          model.ClassID = this.classID;
          model.StudentID = this.studentID;
          model.FeedbackText = assignment.feedbackText ?? "";
          model.Grade = assignment.grade;

          this.APIService.SaveGradeForStudent(model).subscribe((response) => {
            if (response) {
              this.GetColor();
              this.assignment.Grade = assignment.grade;
              this.toastr.success('Student Graded', 'Success!');
            } else {
              this.toastr.error('Something went wrong', 'Failure!');
            }
          });
        }
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  };
}
